
<template>
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
       {{actionToBePerformed}}
      </h1>
    </section>

    <section class="content">
        <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-md-12 col-lg-12">
                <form action="#"  method="post">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">Configuration</h3>
                    </div>
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="name">Country</label>
                              <span title="The keyword and audience query will only work for the country which is selected from this dropdown."><i class="fa fa-info-circle required"></i></span>
                              <nv-select class="form-control" @change="selectedCountry" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.country_id.required }" 
                              id="country_id" v-model="gRowObj.country_id">
                                <option value="">--Choose a Country--</option>
                                <option v-for="data in countryList" 
                                :selected="data.country_id === gRowObj.country_id" :key="data.country_id" :value="data.country_id">{{data.country_name}}</option>                    
                              </nv-select>
                              <span v-if="submitted && !$v.gRowObj.country_id.required" class="text-red pull-right">Please choose a country.</span>
                            </div>
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="type" class="required">Customer</label>                  
                              <nv-select class="form-control" @change="selectedClient" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.client_id.required }" 
                              id="client_id" v-model="gRowObj.client_id" >
                                  <option value="">--Choose a Customer--</option>
                                  <option v-for="data in clientList" :key="data.id" :value="data.id"
                                  :selected="data.id === gRowObj.client_id">{{data.name}}</option>                      
                              </nv-select>
                              <span v-if="submitted && !$v.gRowObj.client_id.required" class="text-red pull-right">Please choose a client.</span>
                            </div>
                        </div>
                      </div>
                      
                      <div class="row">
                          <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                                <label for="name" class="required">Google Sheet URL</label>
                                <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.spreadsheetURL.required }" 
                                v-model="gRowObj.spreadsheetURL" class="form-control" id="spreadsheetURL" placeholder="Google Sheet URL" />
                                <span v-if="submitted && !$v.gRowObj.spreadsheetURL.required" class="text-red pull-right">Please enter URL of Google Sheet.</span>
                            </div>
                          </div>
                      </div>

                    <div class="row"> 
                      <div class="form-group col-xs-12 col-sm-12 col-md-12">
                      <div class="padding-15px v-autocomplete">
                        <label for="client">Select referral type:</label>
                      </div>

                        <ul>
                          <li class="radio-inline"  style="width:150px"> <label> <strong> Physical/Virtual : </strong> </label> </li>
                          <li v-for="(access, index) in refAccessData" class="radio-inline" :key="index">
                            <label class="radio-inline">
                              <input type="radio" name="ref_access" disabled :value="access.id" :checked="gRowObj.ref_access" v-model="gRowObj.ref_access">{{access.type_name}}
                            </label>
                          </li>  
                      </ul>

                                    <ul>
                          <li class="radio-inline"  style="width:150px"> <label> <strong> Ownership : </strong> </label> </li>
                          <li v-for="(ownership, index) in refOwnershipData" class="radio-inline" :key="index">
                            <label class="radio-inline">
                              <input type="radio" name="ref_ownership" :value="ownership.id" :checked="gRowObj.ref_ownership" v-model="gRowObj.ref_ownership">{{ownership.type_name}}
                            </label>
                          </li>  
                      </ul>

                        <ul>
                          <li class="radio-inline"  style="width:150px"> <label> <strong> Medical/Pharmacy : </strong> </label> </li>
                          <li v-for="(service, index) in refServiceData" class="radio-inline" :key="index">
                            <label class="radio-inline">
                              <input type="radio" name="ref_service" :value="service.id" :checked="gRowObj.ref_service" v-model="gRowObj.ref_service">{{service.type_name}}
                            </label>
                          </li>  
                      </ul>

                      <span v-if="submitted && (!$v.gRowObj.ref_service.required || !$v.gRowObj.ref_ownership.required || !$v.gRowObj.ref_access.required)" class="text-red" style="margin-left: 60px">Please select the resource type.</span>
                    </div>


                  </div>
                  </div>
                  </div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">Products/Services available</h3>
                    </div>
                    <div class="panel-body">
                        <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-12 col-sm-12 col-md-6">
                             <div class="row">
                            <label for="name">Services</label>
                            </div>
                              <label class="checkbox-inline padding-botton-15px"><input type="checkbox" @change="selectAllServices('service')" v-model="allSelectedServices" /> Select All</label>
                                <div v-for="service in servicesList" :key="service.id">
                                  <label class="checkbox-inline col-xs-6 col-sm-4 col-md-3 col-lg-6" style="display: inline-table;">
                                      <input  type="checkbox" v-model="gRowObj.services" :value="service.id" @click="selectService('service')"/>{{service.legacy_name}}
                                  </label>
                              </div> 
                          </div>
                          <div class="form-group col-xs-12 col-sm-12 col-md-6">
                            <div class="row">
                            <label for="name">Products</label>
                            </div>
                              <label class="checkbox-inline padding-botton-15px"><input type="checkbox" @change="selectAllServices('product')" v-model="allSelectedProducts" /> Select All</label>
                                <div v-for="data in productList" :key="data.id">
                                  <label class="checkbox-inline col-xs-6 col-sm-4 col-md-3 col-lg-6" style="display: inline-table;">
                                      <input  type="checkbox" v-model="gRowObj.products" :value="data.id" @click="selectService('product')"/>{{data.legacy_name}}
                                  </label>
                              </div> 
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="action-button">
                      <button type="button" class="btn btn-primary" @click="close">Cancel</button>
                      <button type="button" class="btn btn-primary margin-left-20px" @click="validatePhysicalResources()">Validate Sheet</button>
                      <button type="button" class="btn btn-primary margin-left-20px" @click="uploadFacilities()">Upload Facilities from Sheet</button>
                    </div>
                  </div>
                  <div class="row" style="margin: 30px 10px 30px 10px;font-size: medium;line-height:30px;">
                    <label style="font-size: large;" for="notes">Instructions:-</label>
                    <ul>
                      <li><div id="notes">Please upload the Google Sheet in this folder :- <a href="https://drive.google.com/drive/u/1/folders/1YgMYn97VXx7Uu2gon5hWo_PKotWvYlMg" target="_blank">https://drive.google.com/drive/u/1/folders/1YgMYn97VXx7Uu2gon5hWo_PKotWvYlMg</a></div></li>
                      <li><b style="color: red;">CAUTION: </b>The google sheet which needs to be uploaded should only contains the details in a specific format.
                        <ul>
                          <li><b>Facility Name</b></li>
                          <li><b>Latitude</b></li>
                          <li><b>Longitude</b></li>
                          <li><b>Address</b></li>
                          <li><b>Phone Number</b></li>
                          <li><b>Keyword</b></li>
                          <li><b>Facility Type</b></li>
                          <li><b>Pincode</b></li>
                          <li><b>administrative_area_level_1</b></li>
                          <li><b>administrative_area_level_2</b></li>
                          <li><b>administrative_area_level_3</b></li>
                          <li><b>locality</b></li>
                          <li><b>formatted_address</b></li>
                        </ul>
                      </li>
                      <li>The sequence of the data must be followed as shown in the sheet and above format.</li>
                      <li><div id="referenceSheet">Here is a demo sheet for your reference :- <a href="https://docs.google.com/spreadsheets/d/1FZEkxKqis1Dl35TkUp6u1Eu3yMsYFduGJNVAwxnbOzA/edit?usp=sharing" target="_blank">https://docs.google.com/spreadsheets/d/1FZEkxKqis1Dl35TkUp6u1Eu3yMsYFduGJNVAwxnbOzA/edit?usp=sharing</a></div></li>
                    </ul>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    </div>
</template>
<script>
  import Treeselect from '@riophae/vue-treeselect'
  import { required } from 'vuelidate/lib/validators'
  import api from '../../../../utils/api'
  import { getActiveCountryList } from '../../../../utils/utilities'
  import { instanceCountriesMapping } from '../../../../config/constants'
  import { getAccessToken } from '../../../../utils/auth'
  export default {
    name: 'modal',
    components: {
      Treeselect
    },
    validations: {
      gRowObj: {
        country_id: { required },
        client_id: { required },
        spreadsheetURL: { required },
        ref_access: { required },
        ref_ownership: { required },
        ref_service: { required }
      }
    },
    data () {
      return {
        activeCountryList: [],
        loading: false,
        refOwnershipData: [],
        refAccessData: [],
        refServiceData: [],
        allSelectedServices: false,
        allSelectedProducts: false,
        servicesList: [],
        productList: [],
        countryList: [],
        clientList: [],
        gRowObj: {
          country_id: '',
          client_id: '',
          spreadsheetURL: '',
          services: [],
          products: [],
          ref_ownership: '',
          ref_service: '',
          ref_access: ''
        },
        submitted: false,
        submittedRes: false,
        actionToBePerformed: 'Upload Physical Facilities',
        countryName: '',
        countryAlise: '',
        clientName: '',
        keywordExistError: false
      }
    },
    methods: {
      close () {
        this.submitted = false
        this.gRowObj = {
          country_id: '',
          client_id: '',
          spreadsheetURL: '',
          services: [],
          products: [],
          ref_ownership: '',
          ref_service: '',
          ref_access: ''
        }
        this.$router.replace('create')
      },
      getReferralResourceType () {
        this.loading = true
        return new Promise(resolve => {
          api.buildRequest('/getReferralResourceType', 'POST')
          .then(response => {
            if (response.status === 200) {
              const ownershipTypes = ['Public', 'Private']
              const accessTypes = ['Physical']
              const serviceTypes = ['Medical', 'Pharmacy']
              this.referralResourceTypeList = response.data.payload
              // -- for ownership
              const ownershipfilteredArray = response.data.payload.filter(i => ownershipTypes.includes(i.type_name))
              this.refOwnershipData = this.refOwnershipData.concat(ownershipfilteredArray)
              // -- for service
              const servicefilteredArray = response.data.payload.filter(i => serviceTypes.includes(i.type_name))
              this.refServiceData = this.refServiceData.concat(servicefilteredArray)
              // -- for access
              const accessfilteredArray = response.data.payload.filter(i => accessTypes.includes(i.type_name))
              this.refAccessData = this.refAccessData.concat(accessfilteredArray)
              this.gRowObj.ref_access = this.refAccessData[0].id
            }
            resolve(true)
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      selectAllServices (type) {
        if (type === 'service') {
          if (this.allSelectedServices) {
            this.gRowObj.services = []
            for (const services of this.servicesList) {
              this.gRowObj.services.push(services.id)
            }
          } else {
            this.gRowObj.services = []
          }
        } else if (type === 'product') {
          if (this.allSelectedProducts) {
            this.gRowObj.products = []
            for (const product of this.productList) {
              this.gRowObj.products.push(product.id)
            }
          } else {
            this.gRowObj.products = []
          }
        }
      },
      selectService (type) {
        setTimeout(() => {
          if (type === 'service') {
            if (this.gRowObj.services.length === this.servicesList.length) {
              this.allSelectedServices = true
            } else {
              this.allSelectedServices = false
            }
          } else if (type === 'product') {
            if (this.gRowObj.products.length === this.productList.length) {
              this.allSelectedProducts = true
            } else {
              this.allSelectedProducts = false
            }
          }
        })
      },
      async getServicesList () {
        return new Promise(resolve => {
          api.buildRequest('getServicesList', 'POST').then(({ data }) => {
            this.offeringList = data.payload
            this.servicesList = data.payload.filter(obj => obj.type === 'Service')
            this.productList = data.payload.filter(obj => obj.type === 'Product')
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              title: 'Failure',
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      selectedCountry () {
        this.countryList.forEach((country) => {
          if (country.country_id === this.gRowObj.country_id) {
            this.countryAlise = country.country_alise.charAt(0).toUpperCase() + country.country_alise.slice(1)
            this.countryName = country.country_name
            return
          }
        })
      },
      selectedClient () {
        this.clientList.forEach((client) => {
          if (client.id === this.gRowObj.client_id) {
            this.clientName = client.name
            return
          }
        })
      },
      async getCountryList () {
        return new Promise(resolve => {
          api.buildRequest('getCountryList', 'POST').then(({ data }) => {
            const domainName = window.location.hostname
            const possibleCountries = instanceCountriesMapping[domainName].countries
            this.countryList = data.payload.filter(item => item.country_name.toLowerCase() !== 'global' && possibleCountries.includes(item.country_name.toLowerCase()))
            this.countryList.forEach((item) => {
              item.country_name = item.country_name.replace(/ /g, '_')
            })
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              title: 'Failure',
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async getClientList () {
        return new Promise(resolve => {
          api.buildRequest('getClientData', 'POST').then(({ data }) => {
            this.clientList = data.payload
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              title: 'Failure',
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async validatePhysicalResources () {
        console.log('gRowObj', this.gRowObj)
        this.submitted = true
        this.$v.gRowObj.$touch()
        if (this.$v.gRowObj.$invalid) {
          return
        }
        await this.validatePhysical()
        this.submitted = false
      },
      async validatePhysical () {
        this.loading = true
        var param = this.gRowObj

        // To find Google Sheet Id from URL
        param.spreadsheetURL = param.spreadsheetURL.trim()
        param.spreadsheetId = param.spreadsheetURL.split('/d/')[1].split('/edit')[0]

        const gidMatch = param.spreadsheetURL.match(/gid=([0-9]+)/)
        if (gidMatch) {
          param.sheetGid = gidMatch[1]
        }

        console.log('Params to send', param)

        // call add
        return new Promise(resolve => {
          api.buildRequest('validate-physical-resources', 'POST', param, { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getAccessToken()}` } }).then(({ data }) => {
            if (data.payload && data.payload.type === 'success') {
              this.$swal({
                width: 600,
                title: data.payload.text,
                type: 'success',
                html: ` <div>Please validate the data before uploading from <a href="${data.payload.link}" target="_blank">validation sheet</a> and remove resources which are already present.</div>
                      <table style="table-layout:fixed; width:100%; font-size: 14px">
                        <tr>
                          <td>Duplicate Names within sheet</td>
                          <td><div style="max-height: 100px; overflow-y: auto;">${data.payload.duplicateNames.join('\n')}</div></td>
                        </tr>
                        <tr>
                          <td>Duplicate Addresses within sheet</td>
                          <td><div style="max-height: 100px; overflow-y: auto;">${data.payload.duplicateAddresses.join('\n')}</div></td>
                        </tr>
                      </table>`
              })
              resolve()
              this.loading = false
            } else {
              resolve(true)
              this.loading = false
              this.$swal({
                title: data.payload ? data.payload.type : 'error',
                type: 'error',
                html: `<div> ${data.payload ? data.payload.text : 'An error occurred'}</div>
                       <div> Payload: ${JSON.stringify(data.payload)}</div>`
              })
            }
          }).catch(err => {
            resolve(true)
            console.log('err: ', err)
            this.loading = false
            this.$swal({
              title: 'Failure',
              type: 'error',
              text: (err && err.response) ? err.response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async uploadFacilities () {
        console.log('gRowObj', this.gRowObj)
        this.submitted = true
        this.$v.gRowObj.$touch()
        if (this.$v.gRowObj.$invalid) {
          return
        }
        await this.addResources()
        this.submitted = false
      },
      async addResources () {
        this.loading = true
        var param = this.gRowObj

        // To find Google Sheet Id from URL
        param.spreadsheetURL = param.spreadsheetURL.trim()
        param.spreadsheetId = param.spreadsheetURL.split('/d/')[1].split('/edit')[0]
  
        const gidMatch = param.spreadsheetURL.match(/gid=([0-9]+)/)
        if (gidMatch) {
          param.sheetGid = gidMatch[1]
        }

        console.log('Params to send', param)

        // call add
        return new Promise(resolve => {
          api.buildRequest('add-physical-resources', 'POST', param, { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getAccessToken()}` } }).then(({ data }) => {
            if (data.payload && data.payload.type === 'success') {
              this.$swal({
                width: 600,
                title: data.payload.text,
                type: 'success',
                html: `<div>The data is uploaded in the database. Please find <a href="${data.payload.link}" target="_blank">Uploaded Records sheet</a> for more details.</div>`
              })
              resolve()
              this.loading = false
            } else {
              resolve(true)
              this.loading = false
              this.$swal({
                title: data.payload ? data.payload.type : 'error',
                type: 'error',
                html: `<div> ${data.payload ? data.payload.text : 'An error occurred'}</div>
                       <div> Payload: ${JSON.stringify(data.payload)}</div>`
              })
            }
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              title: 'Failure',
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      }
    },
    async mounted () {
      this.gRowObj = {
        country_id: '',
        client_id: '',
        spreadsheetURL: '',
        services: [],
        products: [],
        ref_ownership: '',
        ref_service: '',
        ref_access: ''
      }
      this.loading = true
      await Promise.all([this.getCountryList(), this.getClientList(), this.getServicesList(), this.getReferralResourceType()])
      this.activeCountryList = await getActiveCountryList()
      this.loading = false
    }
  }
</script>
<style>
.margin-left-20px {
  margin-left: 20px;
}
.form-group .padding-15px {
  padding: 0 15px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 90%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.body.modal-mask {
  position:fixed;
  height: 100vh;
  overflow-y: hidden;
}
.modal-header h3 {
  width: 100%;
  margin-top: 0;
  color: black;
}
.modal-body {
  overflow: auto;
  margin: 20px 0;
}
.modal-default-button {
  float: right;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.disable {
  color: #b3b1b1;
}
.v-autocomplete {
  position:relative;
}
.v-autocomplete-input {
  padding:10px 15px;
  height:34px;
}
.v-autocomplete-list {
  width:calc(100% - 30px);
  border:1px solid #d2d6de;
  position:absolute;
  top:58px;
  z-index:111;
  list-style: none;
  padding: 0%;
  max-height: 110%;
  overflow: overlay;
}
.v-autocomplete-list-item {
  width:100%;
  border-bottom:1px solid #d2d6de;
  padding:6px 12px;
  font-size:14px;
  background-color:white;
  cursor:pointer;
}
.v-autocomplete-list-item:last-child {
  width:100%;
  border-bottom:none;
}
.v-autocomplete-list-item:hover {
  background-color: #d2d6de;
}
.msg-table thead, .msg-table tbody{
  display: inline-block;
}
.msg-table thead{
  width: calc(100% - 17px);
}
.msg-table tbody{
  max-height: calc(100vh - 300px);
  overflow: auto;
}
.msg-table th, .msg-table td {
  display: block;
  float: left;
}
.msg-table th:first-child, .msg-table td:first-child{
  width: calc(20% - 53px);
}
.msg-table th:nth-child(2), .msg-table td:nth-child(2), .msg-table th:nth-child(3), .msg-table td:nth-child(3){
  width: 40%;
}
.msg-table th:nth-child(4), .msg-table td:nth-child(4){
  width: 53px;
}
.alert-success{
   background-color:#d4edda !important; 
   border-color:#d4edda !important
}
.alert-danger{
   background-color:#f7d7da !important; 
   border-color:#f7d7da !important
}
.alert-warning{
   background-color:#fff3cd !important; 
   border-color:#fff3cd !important
}
.alert-info{
   background-color:#cce5ff !important; 
   border-color:#cce5ff !important
}

</style>



// WEBPACK FOOTER //
// bulkUploadResources.vue?e758a7c8